import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IAccordionProps } from '../components/accordion/accordion';
import { AccordionItemModel } from './accordion-item-model';
import { IAccordionItemProps } from '../components/accordion/accordion-item/accordion-item';

export class AccordionModel extends ContentItem {
  get accordionItems(): IAccordionItemProps[] {
    const accordionItems = get(
      this._config,
      'elements.accordion_items.value',
      []
    );
    const transformAccordionItems = accordionItems
      ? accordionItems.map((item: IAccordionItem) =>
          AccordionItemModel.create(item)
        )
      : null;
    return transformAccordionItems;
  }

  public static create(data: IAccordion): IAccordionProps {
    const { accordionItems } = new AccordionModel(data);
    return {
      accordionItems
    };
  }
}
